import React, { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';
import '../styles/Comentarios.css';

const Comentarios = () => {
  const [comentarios, setComentarios] = useState([]);
  const [formData, setFormData] = useState({ nombre: '', email: '', comentario: '' });
  const [enviando, setEnviando] = useState(false);
  const [mensaje, setMensaje] = useState(null);

  useEffect(() => {
    cargarComentarios();
  }, []);

  const cargarComentarios = async () => {
    const { data, error } = await supabase
      .from('comentarios')
      .select('id, nombre, comentario, created_at')
      .eq('estado', 'aprobado')
      .order('created_at', { ascending: false });

    if (!error && data) setComentarios(data);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setEnviando(true);
    setMensaje(null);

    const { error } = await supabase.from('comentarios').insert([
      {
        nombre: formData.nombre,
        email: formData.email,
        comentario: formData.comentario,
        estado: 'pendiente',
      },
    ]);

    if (error) {
      setMensaje({ tipo: 'error', texto: 'Hubo un error al enviar. Intente nuevamente.' });
    } else {
      setMensaje({ tipo: 'exito', texto: '¡Gracias por su comentario! Será revisado antes de publicarse.' });
      setFormData({ nombre: '', email: '', comentario: '' });
    }

    setEnviando(false);
  };

  const formatFecha = (fecha) => {
    return new Date(fecha).toLocaleDateString('es-PE', {
      year: 'numeric', month: 'long', day: 'numeric'
    });
  };

  return (
    <section className="comentarios-section" id="comentarios">
      <div className="comentarios-container">

        {/* Título */}
        <div className="section-title">
          <p className="section-subtitle">Opiniones</p>
          <h2>Lo que dicen nuestros clientes</h2>
        </div>

        {/* Comentarios aprobados */}
        {comentarios.length > 0 ? (
          <div className="comentarios-grid">
            {comentarios.map((c) => (
              <div key={c.id} className="comentario-card">
                <div className="comentario-avatar">
                  {c.nombre.charAt(0).toUpperCase()}
                </div>
                <div className="comentario-body">
                  <div className="comentario-header">
                    <span className="comentario-nombre">{c.nombre}</span>
                    <span className="comentario-fecha">{formatFecha(c.created_at)}</span>
                  </div>
                  <p className="comentario-texto">"{c.comentario}"</p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="sin-comentarios">Sé el primero en dejar un comentario.</p>
        )}

        {/* Formulario */}
        <div className="comentario-form-wrapper">
          <h3>Deja tu comentario</h3>
          <form className="comentario-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="nombre">Nombre *</label>
                <input
                  type="text"
                  id="nombre"
                  name="nombre"
                  value={formData.nombre}
                  onChange={handleChange}
                  placeholder="Su nombre"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Su correo (no se publicará)"
                  required
                />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="comentario">Comentario *</label>
              <textarea
                id="comentario"
                name="comentario"
                value={formData.comentario}
                onChange={handleChange}
                placeholder="Cuéntenos su experiencia con nuestros servicios..."
                rows="4"
                required
              />
            </div>

            {mensaje && (
              <div className={`form-mensaje ${mensaje.tipo}`}>
                {mensaje.texto}
              </div>
            )}

            <button type="submit" className="btn-comentario" disabled={enviando}>
              {enviando ? 'Enviando...' : 'Enviar Comentario'}
            </button>
          </form>
        </div>

      </div>
    </section>
  );
};

export default Comentarios;
